export enum SideBarNavigationKey {
  Lobby = 'lobby',
  Promotions = 'promotions',
  Winners = 'winners',
}

// `source` of the Sidebar Open event: what opened the sidebar
export enum SidebarOpenSource {
  // the launcher's opener widget
  Button = 'button',
  // the game's own sidebar button (pgOpenSidebar)
  Game = 'game',
  // the "new games" notification on mobile, which opens the lobby tab
  Lobby = 'lobby',
}
